import React, { Component } from 'react';
import ReportPage from './ReportPage';

class TocPage extends Component {
    render() {
        return (
            <ReportPage {...this.props} title="Table of Contents" className="toc" pageNumber={this.props.pageNumber}>
                <div>
                    <p>{this.props.preparedFor} Retirement Plan Priorities <span>3</span></p>
                    <p>Target-Date Suitability <span>4</span></p>
                    <p>{this.props.preparedFor} Information <span>5</span></p>
                    <p>Glide Path Comparison <span>8</span></p>
                    {this.props.reportIncludesMethodology?
                        <p>Methodology <span>12</span></p>
                    : null }
                </div>
            </ReportPage>
        );
    }
}

export default TocPage;
